import * as React from 'react';
import { Responsive, UIHeading1, UIHeading2 } from '@cian/ui-kit';

import * as style from './SpecialPromosWrapper.css';

interface ISpecialPromosWrapperProps {
  specialPromosPreview: React.ReactElement;
  specialPromos: React.ReactElement;
  showAllPromos: React.ReactElement;
  slider: JSX.Element | null;
}

export const SpecialPromosWrapper = ({
  specialPromosPreview,
  specialPromos,
  showAllPromos,
  slider,
}: ISpecialPromosWrapperProps) => {
  return (
    <section id="promos" className={style['wrapper']} data-testid="SpecialPromos">
      <Responsive desktop>
        <UIHeading1>Акции и спецпредложения</UIHeading1>
        <div>
          {slider && <div className={style['slider-wrapper']}>{slider}</div>}
          <div className={style['promos']}>{specialPromos}</div>
          <div className={style['all-promos']}>{showAllPromos}</div>
        </div>
      </Responsive>
      <Responsive phone tablet>
        <UIHeading2>Акции и спецпредложения</UIHeading2>
        {specialPromosPreview}
      </Responsive>
    </section>
  );
};
